import { useEffect, useState, lazy, useLayoutEffect, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./redux/rootReducers";
import "nprogress/nprogress.css";
import "./App.scss";
import RouteAuth from "./components/RouteAuth/RouteAuth";
import FallBackComponent from "./components/FallBackComponent/FallBackComponent";
import ThemeContext from "./ThemeContext";
import { lang } from "./models";
import { CheckoutProvider } from "./context/CheckoutContext";

import { partnerThemeCrudOperations } from "./redux/actions/getPartnerTheme";
import {
  handleLangugeDirection,
  handleSetLogoAndTitle,
} from "./components/commonFunctions";
import useSessionExpiration from "./CustomHooks/useSessionExpire";
import { useTranslation } from "react-i18next";
import PlanDetailsScreenWrapper from "./screens/AdminRecurring/PlanDetails/PlanDetailsScreenWrapper";
import Users from "./screens/users";

import UserPartnerScreen from "./screens/UserPartnerScreen/UserPartnerDetail";
import InvoiceSummary from "./screens/InoviceSummary/InvoiceSummary";
import { count } from "node:console";
import AccessApi from "./screens/AccessApi/AccessApi";
import MerchantSecret from "./screens/MerchantSecret/MerchantSecret";
import Tickets from "./screens/Tickets/Tickets";
import { isSftpEnabled } from "./utils/envFlags";
const Profile = lazy(() => import("./screens/Profile"));
const TunisiaSoftpostReceipt = lazy(
  () => import("./screens/TunisiaTrxRecipt/tunisiaTrxReceipt"),
);

//const NotifReport = lazy(() => import("./screens/Notifications/ViewNotification"));
const ThreatsDashboard = lazy(
  () => import("./screens/AdminThreatsDashboard/ThreatsDashboard"),
);
const Logs = lazy(() => import("./screens/AdminLogs/Logs"));
const AdminNotification = lazy(() => import("./screens/Notifications"));
const ClickToPayTransactions = lazy(
  () => import("./screens/paymentGatewayScreen/ClickToPay"),
);
const ApplePay = lazy(() => import("./screens/paymentGatewayScreen/Applepay"));
const PartnersReports = lazy(() => import("./screens/Partners/ParnterReports"));
const AdminPaymentDashboard = lazy(
  () => import("./screens/AdminPaymentDashboard/AdminPaymentDashboard"),
);
const OnlineRegisteration = lazy(
  () => import("./screens/AdminOnlineRegisteration/registerationLayout"),
);
const MercahntSoftposDashboard = lazy(
  () => import("./screens/merchantSoftposDashboard/merchantSoftposDashboard"),
);
const MerchantAllDashboard = lazy(
  () => import("./screens/MerchantDashboard/MerchantAllDashboard"),
);
const MerchantList = lazy(() => import("./screens/AdminMerchantList"));
const PartnerList = lazy(() => import("./screens/AdminPartnerList"));
const SendNotification = lazy(
  () => import("./screens/Notifications/SendNotifications"),
);
const ViewNotification = lazy(
  () => import("./screens/Notifications/ViewNotification"),
);
const UserManagementIndex = lazy(
  () => import("./screens/MerchantSettings/UserManagementIndex"),
);
const AdminSoftposDashboard = lazy(
  () => import("./screens/AdminDashboard/AdminDashboard"),
);
const TamaraTransactions = lazy(
  () => import("./screens/paymentGatewayScreen/Tamaratransactions"),
);
const TabbyTransactions = lazy(
  () => import("./screens/paymentGatewayScreen/TabbyTransactions"),
);
const CardApplepay = lazy(
  () => import("./screens/paymentGatewayScreen/CardApplepay"),
);
const LoginScreen = lazy(() => import("./screens/LoginScreen"));
const AdminSettings = lazy(
  () => import("./screens/AdminUserManagement/Profile"),
);
const Transaction = lazy(
  () => import("./screens/paymentGatewayScreen/Transaction"),
);
const Layout = lazy(() => import("./screens/Layout/Layout"));
const MerchantPurchase = lazy(
  () => import("./screens/CheckoutTestPages/PurchaseIniaite"),
);
const PurchaseStatus = lazy(
  () => import("./screens/CheckoutTestPages/PurchaseStatus"),
);
const AppMngmnet = lazy(() => import("./screens/AppMngmnt/AppMngmnet"));
const CreateInvoiceCopy = lazy(
  () => import("./screens/E-invoiceNew/CreateInvoiceScreen"),
);
const AdminRecurring = lazy(
  () => import("./screens/AdminRecurring/AdminRecurring"),
);
const AssignedPlans = lazy(
  () => import("./screens/AssignedPlans/AssignedPlans"),
);

const AdminRecurringDetails = lazy(
  () => import("./screens/DetailsRecurring/DetailsRecurring"),
);
const AdminRecurringPlan = lazy(
  () =>
    import("./screens/AdminRecurring/SubscriptionManagement/SubscriptionManagement"),
);
const LoadingPaymentStatus = lazy(
  () => import("./screens/LoadingPaymentStatus/LoadingPaymentStatus"),
);
const AdminRecurringPayment = lazy(
  () => import("./screens/AdminRecurringPayment/AdminRecurringPayment"),
);
const ViewRecurringPlan = lazy(
  () => import("./screens/AdminRecurring/PlanDetails/PlanDetailsScreen"),
);
const InvoiceHistory = lazy(
  () => import("./screens/E-invoiceNew/InvoiceHistory"),
);
const ReminderDistributeUI = lazy(
  () => import("./screens/E-invoiceNew/ReminderDistributeUI"),
);
const PaymentMethodsIndex = lazy(
  () => import("./screens/AdminPaymentMethods/PaymentMethods"),
);
const Reports = lazy(() => import("./screens/AdminReports/Reports"));
const ProductMng = lazy(() => import("./screens/Products/ProductMng"));
const Customers = lazy(() => import("./screens/Customers/Customers"));
const Configuration = lazy(
  () => import("./screens/AdminConfiguration/Configuration"),
);
const PaymentGatewayDashboard = lazy(
  () => import("./screens/PaymentGatewayDashboard/PaymentGatewayDashboard"),
);
const CommercialProposal = lazy(
  () => import("./screens/CommercialProposal/CommercialProposal"),
);
const CardPaymentStatus = lazy(
  () => import("./screens/CardPaymentStatus/CardPaymentStatus"),
);
const InVoicePayment = lazy(
  () => import("./screens/InvoicePayment/InvoicePayment"),
);
const SDKPaymentOptions = lazy(
  () => import("./screens/SDKPaymentOptions/SDKPaymentOptions"),
);
const SDKPaymentOptions2 = lazy(
  () => import("./screens/SDKPaymentOptions/SDKPaymentClicToPay"),
);
const ClientInvoiceForm = lazy(
  () => import("./screens/ClientInvoice/ClientInvoiceForm"),
);
const PaymentSettings = lazy(() => import("./screenSettings/PaymentSettings"));
const InvoiceScreen = lazy(
  () => import("./screens/EVoiceScreen/InvoiceScreen"),
);
const BranchesScreen = lazy(
  () => import("./screens/BranchesScreen/BranchesScreen"),
);
const UsersScreen = lazy(() => import("./screens/UsersScreen/UsersScreen"));
const TerminalsScreen = lazy(
  () => import("./screens/TerminalsScreen/TerminalsScreen"),
);
const TransactionsScreen = lazy(
  () => import("./screens/TransactionsScreen/TransactionsScreen"),
);
const TerminalsReconcilationScreen = lazy(
  () => import("./screens/ReconcilationScreen/TerminalsReconcilationScreen"),
);
const SftpScreen = lazy(() => import("./screens/AdminReports/Sftp"));
const OTPScreen = lazy(() => import("./screens/OTPScreen"));
const Forgetpassword = lazy(() => import("./screens/ForgetPassword"));
const EmailReceipt = lazy(
  () => import("./components/EmailReceipt/ReceiptScreen"),
);
const Merchant = lazy(() => import("./screens/Merchant"));

const RegisterPage = lazy(
  () => import("./screens/RegisterScreen/RegisterScreen"),
);
const PasswordResetScreen = lazy(
  () => import("./screens/PasswordResetScreen/PasswordResetScreen"),
);
const ErrorUrlScreen = lazy(() => import("./screens/ErrorUrlScreen"));
const MerchantItem = lazy(() => import("./screens/MerchantItem"));
const OutletScreen = lazy(() => import("./screens/OutletScreen"));
const TerminalScreen = lazy(() => import("./screens/TerminalScreen"));
const UserScreen = lazy(() => import("./screens/UserScreen/UserDetail"));
// const Profile = lazy(() => import("./screens/Profile"));
const ReconsilationReceipt = lazy(
  () => import("./screens/ReconcilationScreen/ReceiptScreen"),
);
const InvoiceDetails = lazy(
  () => import("./screens/EVoiceScreen/EinvoiceList/InvoiceDetails"),
);
const EInvoicelist = lazy(() => import("./screens/EVoiceScreen/EinvoiceList"));
const SettingsScreen = lazy(() => import("./screens/settings/SettingsScreen"));
const OtherSettings = lazy(() => import("./screenSettings/OtherSettings"));

// theme.js

const Roles = {
  admin: "admin",
  merchant: "merchant",
  user: "user",
  supervisor: "supervisor",
  partner: "partner",
};

const App = () => {
  const [loggedIn, setLoggedIn] = useState("");
  const dispatch = useDispatch();
  const authApi = useSelector((state: RootState) => state.authReducer);
  const otpApi = useSelector((state: RootState) => state.otpReducer);
  const handleSessionExpire = useSessionExpiration();
  const divs = document.getElementsByTagName("div");
  const hostName = window.location.hostname;
  const location = useLocation();
  const [loggedInPartner, setLoggedInPartner] = useState(authApi?.partnerId);
  const [partners, setPartners]: any = useState({});
  const { t, i18n } = useTranslation("translation");
  //const handleSessionExpire = useSessionExpiration()
  const PartnerThemeApi: any = useSelector(
    (state: RootState) => state.partnerThemeCrudOperationsReducer,
  );
  type CountryCode = "SA" | "PK" | "LB" | "QA" | "TN";
  type Country = CountryCode;

  useEffect(() => {
    if (
      !PartnerThemeApi?.themeData?.content &&
      PartnerThemeApi?.loading !== true
    ) {
      dispatch(partnerThemeCrudOperations("get", hostName));
    }
  }, [hostName, PartnerThemeApi?.themeData?.content]);

  useEffect(() => {
    if (PartnerThemeApi?.themeData?.content) {
      const themesConfig = PartnerThemeApi?.themeData?.content[0];
      const loggedInPartnerData = PartnerThemeApi.themeData.content[0].partners
        ? PartnerThemeApi.themeData.content[0].partners.find(
            (theme: any) => theme.partnerId === loggedInPartner,
          )
        : null;

      const AvailbelCountry = () => {
        const SAAvialablePhoneCountry: Country[] = [themesConfig.countryCode];
        return SAAvialablePhoneCountry;
      };
      const defaultCountry = () => {
        const SADefaultCountry: Country | any = themesConfig.countryCode;
        return SADefaultCountry;
      };
      setPartners({
        partner: {
          name: themesConfig.nameEn,
          nameAR: themesConfig.nameAR,
          hostname: themesConfig.hostName,
          mainDarkColorhexa: themesConfig.mainSecondaryColorHexa,
          mainDarkColorRgba: themesConfig.mainSecondaryColorRgba,
          MainGreenColorHexa: themesConfig.mainPrimaryColorHexa,
          MainGreenColorRgba: themesConfig.mainPrimaryColorRgba,
          mainLightGreenColor: themesConfig.mainSecondaryColorHoverRgba,
          loginPagelogo: themesConfig.loginPageLogo,
          smallLogo: themesConfig.smallLogo,
          loginFigureImage: themesConfig.loginFigureImage,
          loaderImage: themesConfig.loaderImage,
          footer: themesConfig?.footer,
          currencyEn1: loggedInPartner
            ? loggedInPartnerData?.currencyEn
            : themesConfig.currencyEn,
          currencyAr1: loggedInPartner
            ? loggedInPartnerData?.currencyAr
            : themesConfig.currencyAr,
          hostConfigurationId:
            loggedInPartner && loggedInPartnerData?.hostConfigurationId,
          AvailbelCountry: AvailbelCountry(),
          defaultCountry: defaultCountry(),
          StartPhoneNum: loggedInPartner
            ? loggedInPartnerData?.startPhoneNum
            : themesConfig.startPhoneNum,
          partnerId: loggedInPartner
            ? loggedInPartnerData?.partnerId
            : themesConfig.partnerId,
          countryCode: loggedInPartner
            ? loggedInPartnerData?.countryCode
            : themesConfig.countryCode,
          partners: PartnerThemeApi.themeData.content[0].partners,
          projects: loggedInPartner
            ? loggedInPartnerData?.projects.map((project: any) => {
                return {
                  name: project.name,
                  enabled: project.enabled,
                };
              })
            : {
                customerSupport: themesConfig.projects?.customerSupport,
                softPos: themesConfig.projects?.softPos,
                paymentGateway: themesConfig.projects?.paymentGateway,
                invoicing: themesConfig.projects?.invoicing,
                recurringPayment: themesConfig.projects?.recurringPayment,
              },
        },
      });
    }
  }, [PartnerThemeApi, hostName, loggedInPartner]);

  const changeDirection = (direction: string) => {
    for (let index = 0; index < divs.length; index++) {
      divs[index].classList.add(direction);
    }
  };

  useEffect(() => {
    if (PartnerThemeApi?.themeData?.content) {
      try {
        localStorage.setItem("themes", JSON.stringify(partners?.partner));
      } catch (e: any) {
        localStorage.removeItem("themes");
        window.location.reload();
      }
    }
  }, [PartnerThemeApi, partners, loggedInPartner]);

  useLayoutEffect(() => {
    if (PartnerThemeApi?.themeData?.content) {
      handleSetLogoAndTitle(PartnerThemeApi?.themeData?.content[0]?.smallLogo);
      const handleSetCurrencAandPartnername = (
        curr: any,
        partnerName: string,
      ) => {
        localStorage.setItem(
          "defaultCurr",
          curr /* partners.partner?.currencyAr1 */,
        );
        document.title = partnerName; //`${partners?.partner?.nameAR} | لوحة تحكم  `;
      };
      handleLangugeDirection(
        lang,
        "currPartner",
        handleSetCurrencAandPartnername,
        partners.partner,
      );
    }
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", navigator.language?.slice(0, 2));
    }
    i18n?.changeLanguage(lang);
  }, [PartnerThemeApi, lang, partners]);

  useLayoutEffect(() => {
    handleLangugeDirection(lang, "divDirection", changeDirection);
    if (PartnerThemeApi?.themeData?.content) {
      document.documentElement.style.setProperty(
        "--mainGreenColor",
        partners.partner?.MainGreenColorHexa,
      );
      document.documentElement.style.setProperty(
        "--mainDarkcolor",
        partners.partner?.mainDarkColorhexa,
      );
      document.documentElement.style.setProperty(
        "--mainlightGreenColor",
        partners.partner?.mainLightGreenColor,
      );
    }
  }, [PartnerThemeApi, partners, lang]);
  // Public routes that should NOT trigger session expiration
  const isPublicCheckoutRoute = (pathname: string): boolean => {
    return (
      pathname.includes("/merchant/checkout") ||
      pathname.includes("/merchant/checkout2") ||
      pathname.includes("/merchant/paymentStatus") ||
      pathname.includes("/pay-by-link/")
    );
  };

  useLayoutEffect(() => {
    // Skip session expiration check for public checkout routes
    if (isPublicCheckoutRoute(location.pathname)) {
      return;
    }

    if (authApi.exp) {
      const expTime = authApi.exp - new Date().getTime();
      const expTimeout = expTime > 0 ? expTime : 0;
      if (expTimeout <= 0) {
        dispatch({ type: "RESET_AUTH" });
      } else {
        setTimeout(() => {
          handleSessionExpire.show(true);
        }, expTimeout);
      }
    }
  }, [authApi.exp, location.pathname]);

  useEffect(() => {
    if (authApi.role === "admin") {
      setLoggedIn(authApi.role);
    } else if (authApi.role === "partner") {
      setLoggedIn(authApi.role);
    } else if (authApi.role === "merchant") {
      setLoggedIn(authApi.role);
    } else if (authApi.role === "user") {
      setLoggedIn(authApi.role);
    } else if (authApi.role === "supervisor") {
      setLoggedIn(authApi.role);
    } else {
      setLoggedIn("");
    }
  }, [authApi.role]);

  if (!PartnerThemeApi?.themeData?.content || !partners?.partner) {
    return <FallBackComponent backColor={true} />;
  }

  return (
    Object.keys(partners).length > 0 && (
      <div className="Edfapay">
        <CheckoutProvider>
          <ThemeContext.Provider value={partners.partner}>
            {/* {<CustomNav role={authApi.role} otpStatus={otpApi.otpMessage} />} */}
            <Suspense fallback={<FallBackComponent backColor={true} />}>
              <Routes>
                <Route path="/" element={<LoginScreen />} />
                <Route path="/login" element={<LoginScreen />} />
                <Route path="/forget" element={<Forgetpassword />} />
                <Route
                  element={
                    <RouteAuth
                      availableRoles={[Roles.partner, Roles.merchant]}
                    />
                  }
                >
                  <Route
                    path="resetPasswordScreen"
                    element={<PasswordResetScreen />}
                  />
                </Route>
                <Route path={`/Edfapay/Reciept`} element={<EmailReceipt />} />
                <Route
                  path={`/transactions/Reciept`}
                  element={<TunisiaSoftpostReceipt />}
                />
                <Route
                  path="reconciliation/receipt/:id"
                  element={<ReconsilationReceipt />}
                />
                <Route
                  path={`/invoicePayment/:merchantId/:invoiceId`}
                  element={<InVoicePayment />}
                />
                <Route path="/Register" element={<RegisterPage />} />
                <Route
                  path="/merchant/checkout/:orderId/:merchantId"
                  element={<SDKPaymentOptions />}
                />
                <Route
                  path="/merchant/checkout2/:orderId/:merchantId"
                  element={<SDKPaymentOptions2 />}
                />
                <Route
                  path="/pay-by-link/:merchantId"
                  element={<ClientInvoiceForm />}
                />
                <Route
                  path={`/merchant/paymentStatus`}
                  element={<CardPaymentStatus />}
                />
                <Route
                  path={`/CommercialProposal`}
                  element={<CommercialProposal />}
                />
                <Route path={"/purchase"} element={<MerchantPurchase />} />
                <Route path={"/purchaseStatus"} element={<PurchaseStatus />} />
                <Route
                  path="merchant/:merchantId/invoice/:invoiceId/recurringPayment/processing"
                  element={<LoadingPaymentStatus />}
                />
                {/* Public Recurring Payment Route - Accessed from Checkout */}
                <Route
                  path="merchant/:merchantId/invoice/:invoiceId/checkout/recurringPayment"
                  element={<AdminRecurringPayment />}
                />
                <Route
                  path="/*"
                  element={<RouteAuth availableRoles={[Roles.admin]} />}
                >
                  <Route
                    path=":accountType/merchantList"
                    element={<Merchant />}
                  />
                  <Route
                    path=":accountType/SoftposDashboard"
                    element={<AdminSoftposDashboard />}
                  />
                  <Route
                    path=":accountType/PaymentGatewayDashboard"
                    element={<AdminPaymentDashboard />}
                  />
                  <Route
                    path=":accountType/ThreatsDashboard"
                    element={<ThreatsDashboard />}
                  />
                  <Route
                    path=":accountType/userManagement"
                    element={<AdminSettings />}
                  />
                  <Route
                    path=":accountType/appManagement"
                    element={<AppMngmnet />}
                  />
                  <Route
                    path=":accountType/paymentMethods"
                    element={<PaymentMethodsIndex />}
                  />
                  <Route
                    path=":accountType/PartnersReports"
                    element={<PartnersReports />}
                  />
                  <Route path=":accountType/allReports" element={<Reports />} />
                  <Route
                    path=":accountType/configuration"
                    element={<Configuration />}
                  />
                  <Route path=":accountType/adminReports" element={<Logs />} />
                  <Route
                    path=":accountType/notifications"
                    element={<AdminNotification />}
                  />
                  <Route
                    path=":accountType/merchants"
                    element={<MerchantList />}
                  />
                  <Route
                    path=":accountType/partners"
                    element={<PartnerList />}
                  />
                  <Route
                    path=":accountType/onlineRegisteration"
                    element={<OnlineRegisteration />}
                  />
                  {/* <Route
                  path=":accountType/recurring"
                  element={<AdminRecurring />}
                /> */}
                  <Route
                    path=":accountType/recurring/details"
                    element={<AdminRecurringDetails />}
                  />
                  <Route
                    path=":accountType/configuration"
                    element={<Configuration />}
                  />
                  <Route
                    path=":accountType/recurring/:planId"
                    element={<PlanDetailsScreenWrapper />}
                  />

                  <Route
                    path=":accountType/recurring/recurringPlan/:merchantId/:invoiceId"
                    element={<AdminRecurringPlan />}
                  />
                  {/* <Route path="profile" element={<AdminSettings />} /> */}
                  <Route path="profile" element={<Profile />} />
                </Route>
                <Route
                  path="/*"
                  element={
                    <RouteAuth availableRoles={[Roles.admin, Roles.partner]} />
                  }
                >
                  <Route path="admin/access" element={<AccessApi />} />

                  <Route path="partner/:id/access" element={<AccessApi />} />

                  <Route
                    path=":accountType/merchantList/:partnerId"
                    element={<Merchant />}
                  />
                  <Route
                    path=":accountType/usersList/:partnerId"
                    element={<Users />}
                  />
                  <Route
                    path=":accountType/recurring"
                    element={<AdminRecurring />}
                  />
                  <Route
                    path=":accountType/configuration"
                    element={<Configuration />}
                  />
                  <Route
                    path=":accountType/SoftposDashboard/:partnerId"
                    element={<AdminSoftposDashboard />}
                  />
                  <Route
                    path=":accountType/PaymentGatewayDashboard/:partnerId"
                    element={<AdminPaymentDashboard />}
                  />
                  <Route
                    path=":accountType/userManagement/:partnerId"
                    element={<UserManagementIndex />}
                  />
                  <Route
                    path=":accountType/appManagement/:partnerId"
                    element={<AppMngmnet />}
                  />
                  <Route
                    path=":accountType/allReports/:partnerId"
                    element={<Reports />}
                  />
                  <Route
                    path=":accountType/:partnerId/profile"
                    element={<Profile />}
                  />
                  {/* <Route path="partner/configuration/:partnerId" element={<Configuration />} /> */}
                  <Route
                    path="partner/onlineRegisteration/:partnerId"
                    element={<OnlineRegisteration />}
                  />
                </Route>
                <Route
                  path="/*"
                  element={
                    <RouteAuth
                      availableRoles={[
                        Roles.admin,
                        Roles.partner,
                        Roles.merchant,
                        Roles.user,
                        Roles.supervisor,
                      ]}
                    />
                  }
                >
                  <Route path="otp" element={<OTPScreen />} />
                  <Route path="merchant/:id/access" element={<AccessApi />} />
                  <Route
                    path="merchant/:id/secret"
                    element={<MerchantSecret />}
                  />
                  <Route path="tickets" element={<Tickets />} />

                  <Route
                    path={`admin/recurring/`}
                    element={<AdminRecurring />}
                  />
                  <Route
                    path={`merchant/:merchantId/recurring/`}
                    element={<AdminRecurring />}
                  />
                  <Route
                    path={`merchant/:merchantId/recurring/assigned-plans`}
                    element={<AssignedPlans />}
                  />
                  <Route
                    path={`merchant/:merchantId/recurring/reminder-distribute`}
                    element={<ReminderDistributeUI />}
                  />
                  <Route
                    path="merchant/:id"
                    element={<MercahntSoftposDashboard />}
                  />
                  <Route path="merchant2/:id" element={<MerchantItem />} />
                  <Route path="branches" element={<BranchesScreen />} />
                  <Route path="branches/:id" element={<OutletScreen />} />
                  <Route path="merchant/:id/users" element={<UsersScreen />} />
                  <Route
                    path="merchant/:id/productManagement"
                    element={<ProductMng />}
                  />
                  <Route
                    path="merchant/:id/invoice/new/recurringPayment"
                    element={<AdminRecurringPayment />}
                  />
                  <Route
                    path="merchant/:id/invoice/:invoiceId/recurringPayment"
                    element={<AdminRecurringPayment />}
                  />

                  <Route
                    path="merchant/:id/invoice/:invoiceId/checkout/recurringPayment"
                    element={<AdminRecurringPayment />}
                  />
                  <Route
                    path="merchant/:id/invoice/invoiceSummary"
                    element={<InvoiceSummary />}
                  />

                  <Route
                    path="merchant/recurring/recurringPlan/:merchantId/:invoiceId"
                    element={<AdminRecurringPlan />}
                  />

                  <Route
                    path="merchant/:id/userManagement"
                    element={<UserManagementIndex />}
                  />
                  <Route path="users/:id" element={<UserScreen />} />
                  <Route
                    path="partner_users/:id"
                    element={<UserPartnerScreen />}
                  />
                  <Route path="terminals" element={<TerminalsScreen />} />
                  <Route path="terminals/:id" element={<TerminalScreen />} />
                  <Route
                    path="merchant/:id/customers"
                    element={<Customers />}
                  />
                  <Route
                    path="merchant/:id/allDashboard"
                    element={<MerchantAllDashboard />}
                  />
                  <Route
                    path="merchant/:id/viewnotifications"
                    element={<ViewNotification />}
                  />
                  <Route
                    path="transactions/transactionsHistory"
                    element={<TransactionsScreen />}
                  />
                  <Route
                    path="reconciliation/reconciliationHistory"
                    element={<TerminalsReconcilationScreen />}
                  />
                  {isSftpEnabled() && (
                    <Route path="sftp" element={<SftpScreen />} />
                  )}
                  {/*Payment Gateway paths */}
                  <Route
                    path="merchant/:id/paymentGateway/Dashboard"
                    element={<PaymentGatewayDashboard />}
                  />

                  <Route
                    path="merchant/:id/paymentGateway/transactions"
                    element={<Transaction />}
                  >
                    <Route path="CardApplepay" element={<CardApplepay />} />
                    <Route path="Applepay" element={<ApplePay />} />
                    <Route path="Tamara" element={<TamaraTransactions />} />
                    <Route path="Tabby" element={<TabbyTransactions />} />
                    <Route
                      path="ClicToPay"
                      element={<ClickToPayTransactions />}
                    />
                  </Route>

                  {/*E-Invoice paths */}
                  <Route
                    path="merchant/:id/Invoice/createInvoice"
                    element={<CreateInvoiceCopy />}
                  />
                  <Route
                    path="merchant/:id/Invoice/InvoiceList"
                    element={<InvoiceHistory />}
                  />
                  <Route
                    path="merchant/:merchantId/Invoice/:id"
                    element={<InvoiceScreen />}
                  />
                  {/* <Route path="merchant/:id/profile" element={<UserManagementIndex />} /> */}
                  {<Route path="merchant/:id/profile" element={<Profile />} />}
                  <Route
                    path="merchant/:id/settings"
                    element={<SettingsScreen />}
                  >
                    <Route path="Payment" element={<PaymentSettings />} />
                    <Route path="other" element={<OtherSettings />} />
                  </Route>
                  <Route path="e-invoice" element={<EInvoicelist />}>
                    <Route
                      path="eInvoiceList/InvoiceDetails"
                      element={<InvoiceDetails />}
                    />
                  </Route>
                </Route>
                <Route path="*" element={<ErrorUrlScreen />} />
              </Routes>
            </Suspense>
            <div id="edfapay-alert"></div>
          </ThemeContext.Provider>
        </CheckoutProvider>
      </div>
    )
  );
};

export default App;
